import { z } from "zod";
import { adminOperationsExtendedSchemaVersionSchema, adminSafeIdentifierSchema, adminUlidSchema, } from "./admin-operations-core.js";
export const adminCasePurposeSchema = z.enum([
    "CUSTOMER_SUPPORT",
    "GIFT_REDEMPTION",
    "ORDER_PAYMENT",
    "FULFILLMENT",
    "SECURITY_INCIDENT",
    "RECONCILIATION",
]);
export const adminSubjectTypeSchema = z.enum([
    "ADMIN_CONTROL_PLANE",
    "OPERATOR",
    "CASE",
    "CUSTOMER",
    "BOOK",
    "GIFT",
    "VOUCHER",
    "VOUCHER_BATCH",
    "REDEMPTION",
    "CHECKOUT",
    "ORDER",
    "PAYMENT",
    "ENTITLEMENT",
    "FULFILLMENT",
    "WORKFLOW",
    "SUPPORT_TICKET",
    "AUDIT_ARCHIVE",
]);
export const adminOperationsCaseSchema = z
    .object({
    schemaVersion: adminOperationsExtendedSchemaVersionSchema,
    id: adminUlidSchema,
    purpose: adminCasePurposeSchema,
    subjectType: adminSubjectTypeSchema,
    subjectId: adminSafeIdentifierSchema,
    externalReferenceDigest: z
        .string()
        .regex(/^[a-f0-9]{64}$/u)
        .optional(),
    /** The support request a support case was opened for (2026-10-21). */
    supportTicketId: adminSafeIdentifierSchema.optional(),
    state: z.enum(["OPEN", "RESOLVED"]),
    createdBy: z.string().min(1).max(128),
    assignedTo: z.string().min(1).max(128),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    resolvedAt: z.string().datetime().optional(),
    expiresAtEpoch: z.number().int().positive().optional(),
    version: z.number().int().positive(),
})
    .strict();
export const adminCreateCaseCommandSchema = z
    .object({
    purpose: adminCasePurposeSchema,
    subjectType: adminSubjectTypeSchema
        .exclude(["ADMIN_CONTROL_PLANE", "AUDIT_ARCHIVE"])
        .optional(),
    subjectId: adminSafeIdentifierSchema.optional(),
    externalReference: z.string().trim().min(1).max(200).optional(),
    /**
     * The support request this case is for (2026-10-21). The same operator opening the same
     * request again continues its open case, instead of starting another each time.
     */
    supportTicketId: adminSafeIdentifierSchema.optional(),
})
    .strict()
    .refine((value) => Boolean(value.subjectType) === Boolean(value.subjectId), {
    message: "Initial subject type and identifier must be supplied together.",
})
    .refine((value) => !value.supportTicketId || value.purpose === "CUSTOMER_SUPPORT", {
    path: ["supportTicketId"],
    message: "Only a customer-support case is opened for a support request.",
});
export const adminCaseSubjectBindingSchema = z
    .object({
    subjectType: adminSubjectTypeSchema,
    subjectId: adminSafeIdentifierSchema,
    boundAt: z.string().datetime(),
})
    .strict();
export const adminCaseResponseSchema = z
    .object({
    data: z
        .object({
        case: adminOperationsCaseSchema,
        subjects: z.array(adminCaseSubjectBindingSchema).max(50).default([]),
        /** True when an open case for the same support request was continued. */
        continued: z.boolean().optional(),
    })
        .strict(),
})
    .strict();
export const adminCaseListResponseSchema = z
    .object({
    data: z
        .object({
        schemaVersion: adminOperationsExtendedSchemaVersionSchema,
        cases: z.array(adminOperationsCaseSchema).max(50),
        /** When more exist: the `before` of the next, older page (2026-10-21). */
        nextBefore: z.string().max(200).optional(),
    })
        .strict(),
})
    .strict();
//# sourceMappingURL=admin-operations-cases.js.map